import {
  SET_ALL_TEAMS,
  ADD_TEAM_SUCCESS,
  REMOVE_TEAM_SUCCESS,
  UPDATE_TEAM_SUCCESS,
  CLEAR_TEAMS_SUCCESS,
  REGISTER_TEAM_SUCCESS,
  LOAD_TEST_TEAM_DATA_SUCCESS,
  SET_TEAM_RESULTS_SUCCESS,
  SET_TEAM_CW_RESULTS_SUCCESS,
  SET_TEAM_BREAKER_ANSWER_SUCCESS,
  SUBMIT_SCORES_SUCCESS,
  RESET_STORE,
  RESET_QUIZ_DATA,
  SET_QUIZ,
  NEW_USER_RESET,
  LOAD_DEBUG_STATE,
} from "../actionTypes";
import ChromeCast from "services/chromecast";
import { parseBreaker } from "services/util";

/**
 *
 * allTeams: all teams in the database
 * teams: teams in the current quiz
 * scoresSubmitted: boolean to indicate if the scores have been submitted to update the output display
 *
 */
const defaultState = { allTeams: [], teams: [], scoresSubmitted: false };

const teams = (state = defaultState, action) => {
  const { type, payload } = action;
  let updatedTeams = [...state.teams];
  let updatedAllTeams = [...state.allTeams];
  let index = null;
  let allTeamsIndex = null;
  let team = null;

  if (payload && (payload.team || payload.teamId)) {
    team = updatedTeams.find((team) => {
      if (payload.team) {
        return team.teamId === parseInt(payload.team.teamId);
      } else {
        return team.teamId === parseInt(payload.teamId);
      }
    });
  }

  switch (type) {
    case SET_ALL_TEAMS:
      return { ...state, allTeams: payload };

    case REGISTER_TEAM_SUCCESS:
      let teamList = [...state.allTeams];
      teamList.push(payload);
      return {
        ...state,
        allTeams: teamList,
      };

    case ADD_TEAM_SUCCESS:
      // let rounds = Array(payload.quizConfig.format.rounds).fill(null);

      // let teamConfig = {};
      // if (Boolean(payload.quizConfig.format.hasBreaker)) {
      //   teamConfig.breaker = { answer: null, proximity: null, rank: null };
      // }
      // if (Boolean(payload.quizConfig.format.isCrossword)) {
      //   teamConfig.puzzle = new Array(
      //     payload.quizConfig.puzzle.questionCount
      //   ).fill(null);
      // }
      if (!team) updatedTeams.push(payload.team);
      // if(!team) updatedTeams.push({ ...payload.team, rounds, ...teamConfig });
      ChromeCast.updateTeams(updatedTeams);
      return { ...state, teams: updatedTeams };

    case REMOVE_TEAM_SUCCESS:
      index = updatedTeams.findIndex((team) => team.teamId === payload);

      if (index !== -1) updatedTeams.splice(index, 1);
      ChromeCast.updateTeams(updatedTeams);
      return { ...state, teams: updatedTeams };

    case UPDATE_TEAM_SUCCESS:
      index = updatedTeams.findIndex((team) => team.teamId === payload.teamId);
      updatedTeams[index] = { ...team, ...payload.teamData };

      allTeamsIndex = updatedAllTeams.findIndex(
        (team) => team.teamId === payload.teamId
      );
      updatedAllTeams[allTeamsIndex] = {
        ...updatedAllTeams[allTeamsIndex],
        ...payload,
      };

      console.log(updatedTeams);

      ChromeCast.updateTeams(updatedTeams);

      return { ...state, teams: updatedTeams, allTeams: updatedAllTeams };

    case CLEAR_TEAMS_SUCCESS:
      ChromeCast.updateTeams([]);
      return { ...state, teams: [] };

    case SET_TEAM_RESULTS_SUCCESS:
      team.rounds[payload.roundId] = payload.results;
      return { ...state, teams: updatedTeams, scoresSubmitted: false };

    case SET_TEAM_CW_RESULTS_SUCCESS:
      team.puzzle = payload.results;
      return { ...state, teams: updatedTeams, scoresSubmitted: false };

    case SET_TEAM_BREAKER_ANSWER_SUCCESS:
      team.breaker.answer = payload.answer;

      // payload.correctAnswer = "7,123";
      payload.correctAnswer = parseBreaker(payload.correctAnswer);
      // if (typeof payload.correctAnswer === "string") {
      //   // remove commas from the answer and convert to int
      //   payload.correctAnswer = parseInt(
      //     payload.correctAnswer.replace(",", "")
      //   );
      // }

      team.breaker.proximity = Math.abs(payload.correctAnswer - payload.answer);

      //calculate the teams breaker question rank
      var scores = Object.keys(updatedTeams).map(function (key) {
        return updatedTeams[key].breaker.proximity;
      });

      var ordered_scores = scores.sort(function (a, b) {
        return a - b;
      });

      Object.keys(updatedTeams).forEach(function (key) {
        var team = updatedTeams[key];
        team.breaker.rank = ordered_scores.indexOf(team.breaker.proximity) + 1;
      });

      return { ...state, teams: updatedTeams, scoresSubmitted: false };

    case SUBMIT_SCORES_SUCCESS:
      ChromeCast.updateScore(state.teams);
      return { ...state, scoresSubmitted: true };

    case LOAD_TEST_TEAM_DATA_SUCCESS:
      return { ...state, teams: payload };
    case SET_QUIZ:
    case RESET_QUIZ_DATA:
    case RESET_STORE:
    case NEW_USER_RESET:
      return { ...defaultState };
    case LOAD_DEBUG_STATE:
      console.log(payload);
      let debugState = payload.teams;
      return { ...state, ...debugState };
    default:
      return state;
  }
};

export default teams;
